// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.investment-estimate-software[data-v-303fee50] {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/wait.vue"],"names":[],"mappings":";AAyBA;EACA,aAAA;AACA","sourcesContent":["<template>\n  <div class=\"investment-estimate-software\">\n    <h2>开发中</h2>\n    <p>敬请期待</p>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'InvestmentEstimateSoftware',\n  data() {\n    return {\n      // 页面数据\n    }\n  },\n  mounted() {\n    // 页面初始化逻辑\n  },\n  methods: {\n    // 页面方法\n  }\n}\n</script>\n\n<style scoped>\n.investment-estimate-software {\n  padding: 20px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
